import { ProfilePage } from "components/ProfilePage"
import { DocumentCard } from "components/DocumentCard"
import { Button } from "components/Button"
import { useState } from "react"
import { PlusSquareRegular } from "components/Icon/PlusSquareRegular"
import { AddressCard } from "components/Icon/AddressCard"
import { ShieldAlt } from "components/Icon/ShieldAlt"
import { useTranslator } from "components/Translator"
import { Modal, ModalContent } from "components/Modal"
import { ReactComponent as Ffv } from "components/Icon/icons/ffv.svg"
import * as DocumentCertificationType from "enums/DocumentCertificationType"
import { useConnectedUser } from "components/ConnectedUserProvider"
import { Text } from "components/Text"
import { RequireClub } from "components/RequireClub"

export function AccountDocumentIndexPage({
  user,
  infos,
  documents: documentsProps,
  tabs = window.accountNav,
}) {
  const connectedUser = useConnectedUser()
  const [documents, setDocuments] = useState(documentsProps)
  const translator = useTranslator()

  const handleDeleteDocument = (deletedDocument) => {
    setDocuments((prevDocuments) => {
      return prevDocuments.filter(
        (document) => document.id !== deletedDocument.id,
      )
    })
  }

  const isOwnProfile = connectedUser?.id === user.id

  const extraActions = [
    isOwnProfile ? <SelectCertificationsButton key="certifications" /> : null,
    isOwnProfile ? <AddDocumentButton key="add-document" /> : null,
  ].filter(Boolean)

  return (
    <ProfilePage
      user={user}
      tabs={tabs}
      infos={infos}
      extraActions={extraActions}
    >
      {documents.length > 0 ? (
        <div className="space-y-6">
          {documents.map((document) => {
            return (
              <DocumentCard
                document={document}
                key={document.id}
                handleDeleteDocument={handleDeleteDocument}
                ownerId={user.id}
              />
            )
          })}
        </div>
      ) : (
        <Text tag="p">
          {translator.trans(
            "account.document.index.emptyMessage",
            null,
            "pages",
          )}
        </Text>
      )}
    </ProfilePage>
  )
}

const AddDocumentButton = () => {
  const translator = useTranslator()

  return (
    <Button
      iconLeft={<PlusSquareRegular className="w-4 h-4" />}
      href={{
        route: "app_user_document_add",
      }}
      type="button"
      variant="outline"
      color="secondary"
      fullWidth
    >
      {translator.trans("account.document.index.add", null, "pages")}
    </Button>
  )
}

const SelectCertificationsButton = () => {
  const translator = useTranslator()
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <RequireClub
        includeExClub={false}
        messages={{
          title: translator.trans(
            "account.document.index.certifyWall.title",
            null,
            "pages",
          ),
          presentation: translator.trans(
            "account.document.index.certifyWall.presentation",
            null,
            "pages",
          ),
          description: translator.trans(
            "account.document.index.certifyWall.description",
            null,
            "pages",
          ),
          cta: translator.trans(
            "account.document.index.certifyWall.cta",
            null,
            "pages",
          ),
        }}
        actions={
          <Button
            href={translator.trans(
              "account.document.index.certifyWall.safeWomen.href",
            )}
            color={"secondary"}
            variant={"text"}
          >
            {translator.trans(
              "account.document.index.certifyWall.safeWomen.label",
              null,
              "pages",
            )}
          </Button>
        }
      >
        <Button type="button" fullWidth onClick={() => setShowModal(true)}>
          {translator.trans("account.document.index.certify", null, "pages")}
        </Button>
      </RequireClub>

      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        title={translator.trans(
          "account.document.index.certifyModal.title",
          null,
          "pages",
        )}
      >
        <ModalContent>
          <div className="flex flex-col space-y-6">
            <Button
              href={{
                route: "app_user_document_certify",
                params: { type: DocumentCertificationType.USER_IDENTITY },
              }}
              iconLeft={<AddressCard className="w-4" />}
              variant="outline"
              color="secondary"
            >
              {translator.trans(
                "account.document.index.certifyModal.identity",
                null,
                "pages",
              )}
            </Button>
            <Button
              href={{
                route: "app_user_document_certify",
                params: {
                  type: DocumentCertificationType.USER_CERTIFICATION_LEVEL,
                },
              }}
              iconLeft={<Ffv className="w-4" />}
              variant="outline"
              color="secondary"
            >
              {translator.trans(
                "account.document.index.certifyModal.ffvLevel",
                null,
                "pages",
              )}
            </Button>
            <Button
              href={{
                route: "app_user_document_certify",
                params: { type: DocumentCertificationType.BOAT_INSURANCE },
              }}
              iconLeft={<ShieldAlt className="w-4" />}
              variant="outline"
              color="secondary"
            >
              {translator.trans(
                "account.document.index.certifyModal.insurance",
                null,
                "pages",
              )}
            </Button>
          </div>
        </ModalContent>
      </Modal>
    </>
  )
}
